import { Button, Flex } from "@chakra-ui/react"
import {
  Block,
  LabelMedium,
  Link,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import {
  selectIsConnected,
  setOpenModal,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { links } from "#/shared/constants"
import {
  AssetsBridgingSummary,
  AutoMigrateListItem,
} from "#/ui/MigrateToMainnet"
import AccountPanelMats from "#/ui-old/AccountPanel/AccountPanelMats"

import DepositButtons from "../DepositButtons"
import DepositDuration from "../DepositDuration"

import DepositInputWrapper from "./DepositInputWrapper"
import DepositWarning from "./DepositWarning"

export default function DepositForm() {
  const [css, theme] = useStyletron()
  const dispatch = useDappDispatch()
  const isConnected = useDappSelector(selectIsConnected)

  return (
    <Block
      className={css({
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.sizing.scale800,
        flexDirection: "column",
        [theme.mediaQuery.large]: {
          alignItems: "normal",
          flexDirection: "row",
        },
      })}
    >
      <Block
        className={css({
          width: "100%",
          maxWidth: "570px",
          [theme.mediaQuery.large]: {
            width: "60%",
          },
        })}
      >
        <DepositInputWrapper />
        <DepositWarning />
        <DepositDuration mb={0}>
          <Flex
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            mb={4}
          >
            <LabelMedium color="contentSecondary">Lock period</LabelMedium>
            <ParagraphSmall color="contentTertiary">
              Can&apos;t withdraw deposit during lock period
            </ParagraphSmall>
          </Flex>
        </DepositDuration>
        <AutoMigrateListItem isDisabled isChecked />
        <Flex
          alignItems="center"
          gap={16}
          justifyContent="space-between"
          w="100%"
        >
          <AccountPanelMats />
          {isConnected ? (
            <DepositButtons />
          ) : (
            <Button
              variant="primaryBlack"
              color="primary.white.100"
              size="large"
              onClick={() => dispatch(setOpenModal("onboarding"))}
            >
              Sign in
            </Button>
          )}
        </Flex>
      </Block>
      <Block
        className={css({
          maxWidth: "432px",
        })}
      >
        <AssetsBridgingSummary />
        <Block
          className={css({
            textAlign: "center",
            margin: `${theme.sizing.scale600} 0`,
          })}
        >
          <Link href={links.TERMS_OF_USE} target="_blank">
            Terms and conditions
          </Link>
        </Block>
      </Block>
    </Block>
  )
}
